import { Injectable } from '@angular/core';
import { TaskProgressionNotification } from 'src/app/models/ws/notifications/task-progression-notification';
import { TaskProgressionService } from '../task-progression.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationHandlerService {
    /**
     * Constructeur
     */
    constructor(private taskProgressionService: TaskProgressionService) {}

    public handleTaskProgressionNotification(notification: TaskProgressionNotification) {
        this.taskProgressionService.changeStatesSet(notification);
    }
}
